import { useEffect } from 'react'
import { useAuth } from '@praxis/component-auth'
import { usePreferences } from './usePreferences'
import { useMPMEnv } from 'utils/env'
import { useUser } from 'components/user-context'
import { IPreferences } from 'types/user-context'
import { safeTgtLogger } from 'utils/safeTgtLogger'

export const useSetPreferences = (): {
    preferences: IPreferences
    isReady: boolean
} => {
    const { session } = useAuth()

    const { lanId } = session?.userInfo ?? {
        firstName: '',
        lanId: '',
    }
    const env = useMPMEnv()
    const { preferences, setPreferences } = useUser()
    const { data, isError } = usePreferences({
        lanId,
        env,
        accessToken: session?.accessToken ?? '',
    })

    useEffect(() => {
        if (isError) {
            safeTgtLogger.warn('User preferences API failed, using defaults', {
                event: {
                    action: 'preferences_fallback',
                    category: 'user_preferences',
                    outcome: 'fallback',
                },
            })
            // Use default preferences on API error
            const defaultPreferences: IPreferences = {
                app_id: 'mpm',
                user_id: lanId,
                count: 0,
                page: 0,
                per_page: 0,
                user_contexts: [],
            }
            setPreferences(defaultPreferences)
        } else if (data) {
            setPreferences(data)
        }
    }, [data, isError, lanId, setPreferences])

    return {
        preferences: data ?? preferences,
        isReady: !!data || isError,
    }
}
